"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Header = void 0;
var React = _interopRequireWildcard(require("react"));
var _uiKit = require("@cian/ui-kit");
var styles = _interopRequireWildcard(require("./Header.css"));
var _Link = require("../../Link");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const Header = props => {
  return /*#__PURE__*/React.createElement("div", {
    className: styles['header']
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['title']
  }, /*#__PURE__*/React.createElement(_uiKit.UIHeading1, null, props.title, ' ', /*#__PURE__*/React.createElement(_Link.Link, {
    size: "28",
    rel: "target",
    target: "_blank",
    url: props.domrfLink
  }, "\u043D\u0430\u0448.\u0434\u043E\u043C.\u0440\u0444"))), /*#__PURE__*/React.createElement(_uiKit.UIText1, {
    color: 'gray40_100'
  }, props.date));
};
exports.Header = Header;